/**
 * @author PengWen
 * @description 登录实时人数管理
 * @Date 2023/06/21
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool, utils_tool } from '../../../tool';
import { templateConfig, reduxTemplateConfig } from "./config";
import { Table } from 'antd'

let {WizModal, WizDataTable, WizButton} = component_tool;
let { WizContainer, WizReduxTemplate, modelUtils } = framework_tool;

class AuthLoginLogManager extends WizContainer {
    compoentName = 'AuthLoginLogManager';

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    _onLook = (platform) => {
      let { record } = this.props
      console.log("record",record)
      let path = '/authLoginLogListDetail'
      this.jumpPage('push', path, { searchProps: { data: [platform] } })
    }

    _handleCMD(nextProps, nextState, key){
      let o = nextProps[key];
      if (o['success']) {
        wizNotice.success(o['msg']);
        return true;
      } else {
        wizNotice.error(o['msg']);
        return false;
      }
    }

    _componentDidMount() {
      this.getList();
    }

    getList() {
      this.doAction({
        path: 'AuthLoginLog/list',
        payload: {
          key: 'AuthLoginLog@list',
          apiParams: {
          }
        }
      })
    }

    propsAndStateOnChange = {
      dataList: this._businessListOver.bind(this),
    }

    _businessListOver(nextProps, nextState) {
      console.log("nextProps",nextProps)
      if (nextProps.dataList.code == 1) {
        let dataListInfo = nextProps.dataList.data.records
        nextState['dataListInfo'] = dataListInfo
      } else {
        wizNotice.error('操作失败：' + nextProps.dataList.msg);
      }
      return true;
    }

    _render() {
      console.log("this.state",this.state)
      console.log("this.state.dataListInfo",this.state.dataListInfo)
      //let { dataListInfo } = this.state.dataListInfo

      let columns = [
        {
            title:"PC管理端人数",
            name:"pcManagementCount",
            dataIndex: "pcManagementCount",
            tableItem: {
                width:70,
            },
            render: (text, record) => {
              // <WizDataTable.Oper>
              //   <WizButton tooltip={text}
              //     onClick={() => {
              //       e.jumpPage && e.jumpPage(
              //         'push',
              //         '/authLoginLogListDetail',
              //         { searchProps: { data: [3] } }
              //       )
              //     }}>
              //     {text}
              //   </WizButton>
              // </WizDataTable.Oper>
              let buttonProps = {
                type: 'link',
                onClick: () => this._onLook(3)
              }
              console.log("record",record)
              return <WizButton {...buttonProps}>{record.pcManagementCount}</WizButton>
          }
        },
        {
          title:"PC学员端人数",
          name:"pcStudentCount",
          dataIndex: "pcStudentCount",
          tableItem: {
              width:70,
          },
          render: (text, record) => {
            let buttonProps = {
              type: 'link',
              onClick: () => this._onLook(4)
            }
            console.log("record",record)
            return <WizButton {...buttonProps}>{record.pcStudentCount}</WizButton>
          }
        },
        {
          title:"APP人数",
          name:"appCount",
          dataIndex: "appCount",
          tableItem: {
              width:70,
          },
          render: (text, record) => {
            let buttonProps = {
              type: 'link',
              onClick: () => this._onLook(6)
            }
            console.log("record",record)
            return <WizButton {...buttonProps}>{record.appCount}</WizButton>
          }
        },
        {
          title:"雪佛兰企微人数",
          name:"chevroletWxCount",
          dataIndex: "chevroletWxCount",
          tableItem: {
              width:70,
          },
          render: (text, record) => {
            let buttonProps = {
              type: 'link',
              onClick: () => this._onLook(8)
            }
            console.log("record",record)
            return <WizButton {...buttonProps}>{record.chevroletWxCount}</WizButton>
          }
        },
        {
          title:"别克企微人数",
          name:"buickWxCount",
          dataIndex: "buickWxCount",
          tableItem: {
              width:70,
          },
          render: (text, record) => {
            let buttonProps = {
              type: 'link',
              onClick: () => this._onLook(9)
            }
            console.log("record",record)
            return <WizButton {...buttonProps}>{record.buickWxCount}</WizButton>
          }
        },
        {
          title:"凯迪拉克企微人数",
          name:"cadillacWxCount",
          dataIndex: "cadillacWxCount",
          tableItem: {
              width:70,
          },
          render: (text, record) => {
            let buttonProps = {
              type: 'link',
              onClick: () => this._onLook(10)
            }
            console.log("record",record)
            return <WizButton {...buttonProps}>{record.cadillacWxCount}</WizButton>
          }
        },
        {
          title:"凯迪拉克IQ企微人数",
          name:"enterpriseCount",
          dataIndex: "enterpriseCount",
          tableItem: {
              width:70,
          },
          render: (text, record) => {
            let buttonProps = {
              type: 'link',
              onClick: () => this._onLook(7)
            }
            console.log("record",record)
            return <WizButton {...buttonProps}>{record.enterpriseCount}</WizButton>
          }
        },
      ]

      let tableProps = {
          columns,
          dataSource: this.state.dataListInfo,
          pagination: false,
          bordered: true,
          rowKey: 'id'
      }
      console.log("tableProps",tableProps)

      // let _reduxTemplateConfig = reduxTemplateConfig({
      //   templateConfig: templateConfig({jumpPage:this.jumpPage}),
      //   apiDataFormat: {
      //   }
      // })
      //return <WizReduxTemplate {..._reduxTemplateConfig}/>
      return <Table {...tableProps} />
    }

}

const mapStateToProps = (state, ownProps) => {
  const { AuthLoginLog } = state;
  const dataList = modelUtils.getModelEntity(AuthLoginLog, "AuthLoginLog@list");
  return {
    dataList,
  }
};
  
export default connect(mapStateToProps)(AuthLoginLogManager);